import React from 'react'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from 'src/locales/en-US/translation.json'
import translationES from 'src/locales/es-ES/translation.json'

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export const I18nProvider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>
}
